import { motion } from "framer-motion";
import './css/banner.css';
import card from "./img/img-1.PNG";

export default function Banner() {
  return (
    <section className="container" id="home">
      <div className="banner-wrapper">
        <div className="banner-left">
          <motion.h1 animate={{ y: 0, opacity: 1}} initial={{ y: -50, opacity: 0}} transition={{ duration: 1}}>
            Buy and sell digital currencies instantly
          </motion.h1>
          <motion.div
            className="banner-text"
            animate={{ x: 0, y: 0, opacity: 1 }}
            transition={{ duration: 2 }}
            initial={{ x: -50, y: -50, opacity: 0 }}
          >
            <p><span className="logoName">iDeyPay</span> is the cheapest and most secure platform to buy and sell Bitcoin, Perfect Money and Ethereum in Nigeria. Partner with us today and enjoy unparalleled accessibility, speed, efficiency, and security!</p>
            <a className="startBtn" href="#start">Get Started</a>
          </motion.div>
        </div>
        <div className="banner-right">
          <motion.img 
            src={card} alt="[credit card]"
            animate={{ x: 0, y: 0, opacity: 1 }}
            transition={{ duration: 3 }}
            initial={{ x: 50, y: -50, opacity: 0 }}
          />
        </div>
      </div>
    </section>
  )
}